'use client';

import React, { useMemo, useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';

const StandardWallThicknessGrid = () => {
  const [rowData] = useState([
    { diameter: '6″', stdWt: 0.28 },
    { diameter: '8″', stdWt: 0.322 },
    { diameter: '10″', stdWt: 0.365 },
    { diameter: '12″', stdWt: 0.375 },
    { diameter: '16″', stdWt: 0.375 },
    { diameter: '20″', stdWt: 0.5 },
  ]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Pipe Diameter (in.)',
        field: 'diameter',
        width: 180,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#333' },
        flex: 1,
      },
      {
        headerName: 'STD WT (in.)',
        field: 'stdWt',
        width: 180,
        cellStyle: { backgroundColor: '#f0f0f0', color: '#333' },
        flex: 1,
      },
    ],
    []
  );

  return (
    <Box>
      <Typography
        variant="h6"
        mb={2}
        sx={{
          backgroundColor: '#5A7AA1',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        Standard Wall Thickness Table (6″–20″)
      </Typography>

      <Box className="ag-theme-alpine" sx={{ height: 300, width: '100%' }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={{
            resizable: true,
            sortable: false,
            editable: false,
            cellStyle: { textAlign: 'left' },
          }}
          domLayout="autoHeight"
          suppressMovableColumns
        />
      </Box>
    </Box>
  );
};

export default StandardWallThicknessGrid;
